export default function DropDown({formId, dropDown, answers, setAnswers}) {
	let value = '';

	if (dropDown.multiple) {
		value = answers.dropDownsMultiple.find(value => value.id === dropDown.id).value;
	}
	else {
		value = answers.dropDowns.find(value => value.id === dropDown.id).value;
	}

	return (
		<div className={"mb-3"}>
			<label htmlFor={formId + dropDown.id} className={"form-label"}>{dropDown.name}:</label>
			<select form={formId} required={true} id={formId + dropDown.id} className={"form-control"} translate="no" multiple={dropDown.multiple} value={value} onChange={evt => {
				setAnswers(prev => {
					const newState = {...prev};

					let newDropDowns = [];
					if (dropDown.multiple) {
						newDropDowns = [
							...newState.dropDownsMultiple
						];
						newState.dropDownsMultiple = newDropDowns;
					}
					else {
						newDropDowns = [
							...newState.dropDowns
						];
						newState.dropDowns = newDropDowns;
					}


					if (dropDown.multiple) {
						newDropDowns.find(value => value.id === dropDown.id).value = [...evt.target.selectedOptions].map(value => value.value);
					}
					else {
						newDropDowns.find(value => value.id === dropDown.id).value = evt.target.value;
					}

					console.log("new dropdown");

					return newState;
				});
			}}>
				{!dropDown.multiple && <option value={""}>Select an option</option>}
				{dropDown.options.map(option => {
					return <option value={option.name} key={option.id} translate="no">{option.name}</option>
				})}
			</select>
		</div>
	);
}